export default __webpack_public_path__ + "static/media/test.0acb1d24.jpg";